export default __webpack_public_path__ + "static/media/Jessica 9781846164958.f7ae8dbd.jpg";